import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/contentRequest.css';

const ContentRequestForm = () => {
  const [formData, setFormData] = useState({
    contentSubject: '',
    targetAudience: '',
    assignedWriter: '',
    contentType: 'LinkedIn Post'
  });

  const [writers, setWriters] = useState([]);
  const [status, setStatus] = useState({
    loading: false,
    error: null,
    success: false
  });

  // Fetch writers from n8n API with authentication
  useEffect(() => {
    axios.get('https://n8n.iniai.cloud/webhook/get-linkedin-writers', {
      headers: {
        'x-api-key': 'auth_k_2f9a8b3c7d6e4f5g9h8i1j2k3l4m5n6', // Add API Key
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      console.log("API Raw Response:", response.data); // Debugging
      const formattedWriters = response.data
        .filter(writer => writer.Name) // Ensure only valid records
        .map(writer => ({
          id: writer.id,
          name: writer.Name // Use correct field name from API
        }));
      console.log("Formatted Writers:", formattedWriters); // Debugging
      setWriters(formattedWriters);
    })
    .catch(error => console.error('Error fetching writers:', error));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, error: null, success: false });

    try {
      await axios.post('https://n8n.iniai.cloud/webhook/content-request-form', formData, {
        headers: {
          'x-api-key': 'auth_k_2f9a8b3c7d6e4f5g9h8i1j2k3l4m5n6', // Add API Key
          'Content-Type': 'application/json'
        }
      });
      setStatus({ loading: false, error: null, success: true });
      setFormData({ contentSubject: '', targetAudience: '', assignedWriter: '', contentType: 'LinkedIn Post' });
    } catch (error) {
      setStatus({ loading: false, error: error.message || 'Something went wrong', success: false });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="content-request-container">
      <div className="content-request-header">
        <h2>Content Request Form</h2>
        <p>Submit your content creation request</p>
      </div>
      
      <form onSubmit={handleSubmit} className="content-request-form">
        <div className="form-group">
          <label htmlFor="contentSubject">Content Subject</label>
          <input
            type="text"
            id="contentSubject"
            name="contentSubject"
            value={formData.contentSubject}
            onChange={handleChange}
            required
            placeholder="What is this content about?"
          />
        </div>

        <div className="form-group">
          <label htmlFor="targetAudience">Target Audience</label>
          <input
            type="text"
            id="targetAudience"
            name="targetAudience"
            value={formData.targetAudience}
            onChange={handleChange}
            required
            placeholder="Who is this content for?"
          />
        </div>

        <div className="form-group">
          <label htmlFor="assignedWriter">Assigned Writer</label>
          <select
            id="assignedWriter"
            name="assignedWriter"
            value={formData.assignedWriter}
            onChange={handleChange}
            required
          >
            <option value="">Select a writer</option>
            {writers.map(writer => (
              <option key={writer.id} value={writer.name}>{writer.name}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="contentType">Content Type</label>
          <select
            id="contentType"
            name="contentType"
            value={formData.contentType}
            onChange={handleChange}
          >
            <option value="LinkedIn Post">LinkedIn Post</option>
          </select>
        </div>

        {status.error && <div className="status-message status-error">{status.error}</div>}
        {status.success && <div className="status-message status-success">Content request submitted successfully!</div>}

        <button type="submit" disabled={status.loading}>
          {status.loading ? 'Submitting...' : 'Submit Content Request'}
        </button>
      </form>
    </div>
  );
};

export default ContentRequestForm;
